import { CiBaseball } from "react-icons/ci";
import { CiCoins1 } from "react-icons/ci";
import { CiBoxes } from "react-icons/ci";
import { CiBullhorn } from "react-icons/ci";
import { CiCoffeeCup } from "react-icons/ci";
import { CiDumbbell } from "react-icons/ci";
import { CiFries } from "react-icons/ci";
import { CiMoneyBill } from "react-icons/ci";

import { AiFillGithub } from "react-icons/ai";
import { AiOutlineCodepen } from "react-icons/ai";
import { AiFillYoutube } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";

export const headerMenus = [
    {
        title: "삼성전자 DS 일정동기화 일정동기화 ",
        icon: <CiBaseball />,
        submenu:["일반1", "공지사항1", "문서 관리1"]
    },
    {
        title: "한독 하모니",
        icon: <CiMoneyBill />,
        src: "/channel",
        submenu:["일반", "공지사항", "문서 관리"]
       
    },
   
];

